import { Component, Inject, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { AbstractComponent } from '../../../../commons/abstract.component';
import { Pager } from '../../../../commons/pager';
import { UtilHelper } from '../../../../helpers/util.helper';
import { Category } from '../../../../models/category.model';
import { ChannelTypeEnum } from '../../../../models/enum/channel.type';
import { ResponseTypeEnum } from '../../../../models/enum/response.type';
import { Response } from '../../../../models/response.model';
import { CategoryService } from '../../../../services/category.service';
import { ResponseService } from '../../../../services/response.service';
import { ButtonZapiComponent } from '../../button-zapi/button-zapi.component';
import { PreviewMediaComponent, PreviewMediaData } from '../../preview-media/preview-media.component';
import { ModalResponseFastData } from '../modal-response-fast.component';

@Component({
    selector: 'bottom-sheet-response-fast',
    templateUrl: './bottom-sheet-response-fast.v2.component.html',
    // templateUrl: './bottom-sheet-response-fast.component.html',
    styleUrls: ['./bottom-sheet-response-fast.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BottomSheetResponseFastComponent extends AbstractComponent {
  listCategory: Array<Category> = new Array<Category>();

  pager: Pager<Response> = new Pager<Response>({ perPage: 4 });

  loadingSpinnerSubject = new BehaviorSubject<boolean>(true);
  loadingSpinner$ = this.loadingSpinnerSubject.asObservable();

  isTableResponseApp: boolean;

  constructor(
    injector: Injector,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: ModalResponseFastData,
    private _bottomSheetRef: MatBottomSheetRef<BottomSheetResponseFastComponent>,
    private categoryService: CategoryService,
    private responseService: ResponseService,
    private _modalPreview: MatDialog,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getList(this.searchString);
    this.getListCategory();
  }

  search(term: string): void {
    this.searchString = term;
    this.pager.page = 1;
    this.getList(term);
  }

  selectedResponseFast(response: Response): void {
    if (response.midia) {
      const dialogRefPreview = this._modalPreview.open(PreviewMediaComponent, {
        width: '600px',
        data: <PreviewMediaData>{
          response,
          midia: response.midia,
          message: response.message,
          isTableResponseApp: true
        }
      });

      dialogRefPreview.afterClosed().subscribe((result: PreviewMediaData) => {
        if (result) {
          this._bottomSheetRef.dismiss(result);
        }
      });
    } else if (Array.isArray(response?.buttonActions) && response?.buttonActions?.length > 0) {
      // RCS does not support buttons at all (RF-10)
      if (this.data?.channel?.type === ChannelTypeEnum.RCS_API) {
        this.alertService.error(this.t('attendance.chat.rcsButtonsNotSupported'));
        return;
      }

      if (this.data?.channel?.type === ChannelTypeEnum.CLOUD_API) {
        const hasNonReplyButtons = response.buttonActions.some(btn =>
          btn.type && btn.type.toLowerCase() !== 'reply'
        );

        if (hasNonReplyButtons) {
          return;
        }
      }

      const dialogRefPreview = this._modalPreview.open(ButtonZapiComponent, {
        width: '600px',
        data: {
          buttonActionsArray: response?.buttonActions,
          maxButtons: response?.buttonActions?.length || 0,
          title: response.title,
          message: response.message,
          footer: response.footer,
          showFullMessage: true,
          previewOnly: true,
          showConfirmButton: true,
        }
      });

      dialogRefPreview.afterClosed().subscribe((result) => {
        if (result) {
          this._bottomSheetRef.dismiss(response);
        }
      });
    } else {
      this._bottomSheetRef.dismiss(response);
    }
  }

  selectedCategory(category: string): void {
    this.getList(category);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList(this.searchString);
  }

  getList(termSearch: string): void {
    this.loadingSpinnerSubject.next(true);

    this.searchParams = {
      company: this.getIDCurrentCompany(),
      type: ResponseTypeEnum.QUICK,
      channelType: this.data?.channeltype
    };

    this.responseService.getAll(this.pager.page, this.pager.perPage, termSearch, this.searchParams).subscribe({
      next: (value: Pager<Response>) => {
        this.pager = value;
      },
      complete: () => this.loadingSpinnerSubject.next(false),
    });
  }

  private getListCategory(): void {
    this.categoryService.getList().subscribe({
      next: (value) => {
        this.listCategory = value;
      },
    });
  }

  public getFileExtension(item: Response): string {
    if (item.buttonActions?.length > 0) {
      return this.t('shared.bottomSheetResponseFast.fileTypeButton')
    }
    if (item.vcardContact) {
      return this.t('shared.bottomSheetResponseFast.fileTypeContact');
    }
    if (item.place) {
      return this.t('shared.bottomSheetResponseFast.fileTypeLocation');
    }
    return UtilHelper.getFileExtension(item.contentType);
  }


}
